import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./Layout.css"; 
import logo from '../assets/logopng.png'; 
import dashboard from '../assets/icons/dashboard.png'; 
import menu from '../assets/icons/menu.png'; 
import maintenance from '../assets/icons/maintenance.png'; 
import tools from '../assets/icons/Tools.png'; 
import logout from "../assets/icons/logout.png";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import profileHome from '../../shared/assets/icons/profileHome.png';
import { MOBILE_BREAKPOINT } from '../../shared/constants/uiConstants';
const Layout = () => {
  const navigate = useNavigate(); 
  const location = useLocation();
  const { logout: authLogout } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(() => {
    const saved = sessionStorage.getItem('sidebarSelectedIndex');
    return saved ? parseInt(saved, 10) : 0;
  });

  const menuItems = [
    { to: "/dashboard", icon: dashboard, label: "Dashboard" },
    { to: "/tasklist", icon: maintenance, label: "Maintenance Request" },
    { to: "/equipmentlist", icon: tools, label: "Equipment" },
    { to: "profile", icon: profileHome, label: "Profile" }
  ];

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const logoutUser = () => {
    authLogout();
    navigate('/');
  };

  // Detect screen size for mobile devices
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update selected index based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    const currentIndex = menuItems.findIndex(item => item.to === currentPath);
    if (currentIndex !== -1) {
      setSelectedIndex(currentIndex);
      sessionStorage.setItem('sidebarSelectedIndex', currentIndex.toString());
    }
  }, [location.pathname]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Skip if typing in input fields
      if (document.activeElement.tagName === 'INPUT' || 
          document.activeElement.tagName === 'TEXTAREA' ||
          document.activeElement.tagName === 'SELECT' ||
          document.activeElement.isContentEditable) {
        return;
      }

      // Check if current path is NOT exactly one of the main menu routes
      // This prevents keyboard navigation on child routes (like add screens)
      const isOnMainRoute = menuItems.some(item => item.to === location.pathname);
      if (!isOnMainRoute) {
        return; // Don't handle keyboard navigation on sub-routes
      }
      
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = selectedIndex > 0 ? selectedIndex - 1 : menuItems.length - 1;
        setSelectedIndex(newIndex);
        sessionStorage.setItem('sidebarSelectedIndex', newIndex.toString());
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = selectedIndex < menuItems.length - 1 ? selectedIndex + 1 : 0;
        setSelectedIndex(newIndex);
        sessionStorage.setItem('sidebarSelectedIndex', newIndex.toString());
      } else if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        // Navigate to the selected menu item
        navigate(menuItems[selectedIndex].to);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex, menuItems, navigate, location.pathname]);

  if (isMobile) {
    return (
      <main className="main-content">
        <Outlet />
      </main>
    );
  }

  return (
    <div className={`layout ${isSidebarCollapsed ? "collapsed" : ""}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            {!isSidebarCollapsed && <img src={logo} alt="TykVen Logo" className="logo" />}
            {!isSidebarCollapsed && <span>TykVen Client</span>}
          </div>
          <button className="menu-toggle" onClick={toggleSidebar}>
            <img src={menu} alt="Menu Icon" />
          </button>
        </div>
        <nav className="menu">
          {menuItems.map((item, index) => (
            <NavLink 
              key={item.to}
              to={item.to} 
              className={({ isActive }) => {
                const classes = ["menu-item"];
                if (isActive) classes.push("active");
                if (selectedIndex === index) classes.push("selected");
                return classes.join(" ");
              }}
              style={{
                backgroundColor: selectedIndex === index ? '#0077FF' : 'transparent'
              }}
              onClick={() => {
                setSelectedIndex(index);
                sessionStorage.setItem('sidebarSelectedIndex', index.toString());
              }}
            >
              <img 
                src={item.icon} 
                alt={`${item.label} Icon`} 
                className="menu-icon" 
                style={item.label === "Profile" ? { width: '20px', height: '20px' } : {}}
              />
              {!isSidebarCollapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;